export default __webpack_public_path__ + "static/media/winner1.140b1e37.svg";